/**
 * @description coupon Action
 */

import {checkCoupon, receiveCoupon, getCouponWithProductInfo, getReceiveuseCouponNewList, getAuthCoupon} from '../../services/'
import { types } from '../constants/types'
import config from '../../config/'
const { UPDATE_SUBIMT_COUPON, UPDATE_COUPON_LIST, RESET_COUPON_LIST, RESET_PRODUCT_AVALIABLE_COUPON_LIST, UPDATE_PRODUCT_RESET_COUPON_LIST, UPDATE_RECEIVED_COUPON_STATE, COUNT_MAX_COUPON_INFO } = types

export default {
  // 请求优惠券信息
  fetchCoupon({ commit, rootState }){
    const { client } = rootState
    return new Promise((resolve, reject) => {
      getAuthCoupon({
        authToken: client.user.token
        , clientId: client.client.clientVersionId
      })
        .then(({data}) => {
          if (data.result === 'SUCCESS') {
            // 先重置
            commit(RESET_PRODUCT_AVALIABLE_COUPON_LIST)
            commit(UPDATE_PRODUCT_RESET_COUPON_LIST, data.datas)
            resolve(data)
          } else {
            reject(data)
          }
        })
        .catch(e => reject(e))
    })
  }
  // 领取优惠券
  , receiveCoupon ({commit, rootState}, { index, couponCode }) {
    const { client } = rootState
    return new Promise((resolve, reject) => {
      receiveCoupon({
        authToken: client.user.token, // 用户ID
        couponCode: couponCode, // 优惠券编码
        clientId: client.client.clientVersionId // 客户端ID
      })
        .then(res => {
          let {data} = res
          if (data.result === 'SUCCESS') {
            commit(UPDATE_RECEIVED_COUPON_STATE, { index, status: 'success' })
            resolve(data)
          } else {
            commit(UPDATE_RECEIVED_COUPON_STATE, { index, status: 'error' })
            reject(data)
          }
        })
        .catch(e => {
          commit(UPDATE_RECEIVED_COUPON_STATE, { index, status: 'error' })
          reject(e)
        })
    })
  }
  // 请求商品优惠券信息
  , fetchProductCoupon ({ commit, rootState }) {
    // reset before update cause it when repeat update
    // validCoupon 获取可用优惠券
    commit(RESET_COUPON_LIST)
    commit(UPDATE_SUBIMT_COUPON, { couponInfo: {} })
    const { client, product } = rootState
    const { skuDetail } = product
    return new Promise((resolve, reject) => {
      getCouponWithProductInfo({
        authToken: client.user.token, // 用户ID
        userId: client.user.userID, // 用户ID
        clientId: client.client.clientVersionId,
        orderFee: skuDetail.sellingPrice,
        authType: config.authType, // 授权类型
        productList: [{
          skuId: skuDetail.skuId, // 单品ID
          productId: skuDetail.productId, // 商品ID
          productCode: skuDetail.clientProductId, // 商品编码
          productTypeId: skuDetail.entityTypeId, // 商品类型ID
          capacity: 1, // 单品数量
          price: skuDetail.sellingPrice, // 单品下单价格
          skuFee: skuDetail.sellingPrice, // 单品总金额
          isPromotion: 0 // 传1是限制不给用优惠券
        }]
      })
        .then(res => {
          let { data } = res
          if (data.result === 'SUCCESS' && data.recordCount > 0) {
            commit(UPDATE_COUPON_LIST, { data })
            commit(COUNT_MAX_COUPON_INFO, { data })
            resolve(data)
          } else {
            reject(data)
          }
        })
        .catch(e => reject(e))
    })
  },
  // 获取商品可领取优惠券信息
  getProductAvaliableCouponList ({ commit, rootState }, {productId}) {
    const { client, product } = rootState
    const { skuDetail } = product
    return new Promise((resolve, reject) => {
      getReceiveuseCouponNewList({
        authToken: client.user.token, // 用户ID
        productTypeCode: skuDetail.entityTypeCode, // 商品类型ID
        clientId: client.client.clientVersionId, // 客户端ID
        productId,
        authType: config.authType, // 授权类型
        authCode: config.authCode // 授权码
      }).then(res => {
        let {data} = res
        if (data.result === 'SUCCESS') {
          // 先重置
          commit(RESET_PRODUCT_AVALIABLE_COUPON_LIST)
          // 获取用户可领取的优惠券
          commit(UPDATE_PRODUCT_RESET_COUPON_LIST, {receiveList: data.datas.receiveDatas, userList: data.datas.useDatas})
          resolve(data.datas)
        } else {
          reject(data)
        }
      }).catch(e => reject(e))
    })
  },
  // 更新提交信息优惠券
  updateCouponInfo ({ commit }, { couponInfo }) {
    commit(UPDATE_SUBIMT_COUPON, { couponInfo })
  },
  // 验证优惠码
  validateCouponCode ({ commit, rootState }, { couponCode }) {
    const { product, client } = rootState
    const { skuDetail } = product
    commit(UPDATE_SUBIMT_COUPON, { couponInfo: {} })
    let couponData = {
      clientId: client.client.clientVersionId,
      orderFee: skuDetail.sellingPrice,
      couponNo: couponCode, // 优惠券兑换码，下单前用户输入
      productList: [{ // 商品列表
        skuId: skuDetail.skuId, // 单品ID
        productId: skuDetail.productId, // 商品ID
        productCode: skuDetail.clientProductId, // 商品编码
        productTypeId: skuDetail.entityTypeId, // 商品类型ID
        capacity: '1', // 单品数量
        price: skuDetail.sellingPrice, // 单品下单价格
        skuFee: skuDetail.sellingPrice, // 单品总金额
        isPromotion: 0 // 是否促销商品
      }]
    }
    return new Promise((resolve, reject) => {
      checkCoupon(couponData)
        .then(res => {
          let { data } = res
          if (data.result === 'SUCCESS') {
            if (data.datas.isUsable === '1') {
              commit(UPDATE_SUBIMT_COUPON, { couponInfo: Object.assign({ couponNo: couponCode }, data.datas) })
              resolve(data.datas)
            } else {
              reject(data)
            }
          } else {
            reject(data)
          }
        })
        .catch(e => reject(e))
    })
  }

}
